export const additionalSounds = [
    {
        src: "sounds/cow.mp3",
        id: "cow",
    },
];
